module.exports = __webpack_public_path__ + "img/parents.e33b4bd2.svg";